import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const FileUpload = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const [modalData, setModalData] = useState({
        id: null,
        image_file: null,
        image_name: "",
    });

    const [galleryImages, setGalleryImages] = useState([]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, [school_slug]);

    const fetchContent = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/general_settings/get_all_files/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                console.log(res.data);
                setGalleryImages(res.data.data || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* ---------------- Handler --------------- */

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setModalData(prev => ({
                ...prev,
                image_file: file,
                image_name: file.name,   // ✅ auto image name
            }));
        }
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this image?")) return;
        const formData = new FormData();
        formData.append("id", id);
        try {
            const res = await axios.post(
                `${baseAPIUrl}admin/general_settings/delete_file`,
                formData,
                { withCredentials: true }
            );

            // Remove from UI instantly
            if (res.data.status === 1) {
                setGalleryImages(prev => prev.filter(img => img.id !== id));
            } else {
                alert(res.data.message || "Delete failed");
            }
        } catch (err) {
            console.error(err.response);
            alert(err.response?.data?.message || "Failed to delete image");
        }
    };

    const handleSave = async () => {
        const formData = new FormData();

        formData.append("school_slug", school_slug);
        formData.append("image_name", modalData.image_name);

        if (modalData.image_file) {
            formData.append("image", modalData.image_file);
        }

        try {
            const url = `${baseAPIUrl}admin/general_settings/add_files`;

            const res = await axios.post(url, formData, {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            });
            
            if (res.data && res.data.status === 1) {
                scrollToTop();
                setShowModal(false);
                fetchContent(); // reload table
            } else {
                const errMsg = res.data?.message || res.data?.msg || "Failed to save file.";
                alert(errMsg);
                if (errMsg.toLowerCase().includes("unauthorized") || errMsg.toLowerCase().includes("please login")) {
                    localStorage.removeItem("isLoggedIn");
                    localStorage.removeItem("school_slugs");
                    window.location.href = "/admin";
                }
            }
        } catch (err) {
            console.error(err);
            const errMsg = err.response?.data?.message || err.response?.data?.msg || "Failed to save file.";
            alert(errMsg);
            if (errMsg.toLowerCase().includes("unauthorized") || errMsg.toLowerCase().includes("please login")) {
                localStorage.removeItem("isLoggedIn");
                localStorage.removeItem("school_slugs");
                window.location.href = "/admin";
            }
        }
    };

    const isImageFile = (filename) => {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(filename);
    };

    const isDocFile = (filename) => {
        return /\.(pdf|doc|docx)$/i.test(filename);
    };

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            alert("Copied to clipboard!");
        } catch (err) {
            console.error("Copy failed", err);
            alert("Failed to copy");
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">File upload</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">File upload</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4>File upload</h4>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            <button className="btn btn-primary" onClick={() => {
                                                setIsEdit(false);
                                                setModalData({
                                                    id: null,
                                                    image_name: "",
                                                    image_file: null,
                                                });
                                                setShowModal(true);
                                            }}>Add file</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover text-nowrap">
                                        <thead className="thead-light">
                                            <tr>
                                                <th style={{ width: "80px" }}>#</th>
                                                <th>File</th>
                                                <th>File name</th>
                                                <th>File path</th>
                                                <th style={{ width: "150px" }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {galleryImages.length > 0 ? (
                                                galleryImages.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>

                                                        <td>
                                                            {isImageFile(item.file_name) ? (
                                                                <img
                                                                    src={`${baseAPIUrl}assets/mandatory_disclosure/${item.file_name}`}
                                                                    alt="News"
                                                                    style={{
                                                                        width: "120px",
                                                                        height: "80px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "6px",
                                                                    }}
                                                                />
                                                            ) : isDocFile(item.file_name) ? (
                                                                <a
                                                                    href={`${baseAPIUrl}assets/mandatory_disclosure/${item.file_name}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-outline-primary btn-sm"
                                                                >
                                                                    <i className="fas fa-file-alt mr-1"></i> View Document
                                                                </a>
                                                            ) : (
                                                                <span className="text-muted">Unsupported file</span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {item.file_name}
                                                            <button
                                                                className="btn btn-sm btn-light ml-2"
                                                                title="Copy file name"
                                                                onClick={() => copyToClipboard(item.file_name)}
                                                                style={{
                                                                    marginLeft: "8px",
                                                                    background: "#0d6efd",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "50%",
                                                                    width: "32px",
                                                                    height: "32px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <i className="fas fa-copy"></i>
                                                            </button>
                                                        </td>
                                                        <td>
                                                            ${baseAPIUrl}assets/mandatory_disclosure/{item.file_name}
                                                            <button
                                                                className="btn btn-sm btn-light ml-2"
                                                                title="Copy file URL"
                                                                onClick={() =>
                                                                    copyToClipboard(
                                                                        `${baseAPIUrl}assets/mandatory_disclosure/${item.file_name}`
                                                                    )
                                                                }
                                                                style={{
                                                                    marginLeft: "8px",
                                                                    background: "#0d6efd",
                                                                    color: "#fff",
                                                                    border: "none",
                                                                    borderRadius: "50%",
                                                                    width: "32px",
                                                                    height: "32px",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <i className="fas fa-copy"></i>
                                                            </button>
                                                        </td>

                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleDelete(item.id)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No data found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "flex",
                        alignItems: "center",      // ✅ vertical center
                        justifyContent: "center",  // ✅ horizontal center
                        backgroundColor: "rgba(0,0,0,0.5)",
                        inset: 0,
                        zIndex: 1050,
                    }}
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: "80%", margin: 0, width: "100%" }}>
                        <div className="modal-content" style={{ maxWidth: "80%", margin: "0 auto", width: "100%" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Add File
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {/* Image Upload */}
                                <div className="form-group">
                                    <label>Upload file</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        onChange={handleImageChange}
                                    />
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-success" onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div >
    )
}
export default FileUpload;